import PropTypes from "prop-types";
import uuid from "react-uuid";

export function BallSwitch({ tabs, setActiveTab, activeTab }) {
  return (
    <div
      style={{
        backgroundColor: "#2977A4",
        width: "100%",
        padding: "14px 62px",
      }}
    >
      <div
        style={{
          backgroundColor: "#7BAAC5",
          display: "flex",
          flexDirection: "row",
          borderRadius: 8,
        }}
      >
        {tabs.map((i, index) => (
          <div
            key={uuid()}
            aria-hidden="true"
            role="button"
            tabIndex="0"
            onClick={() => setActiveTab(index)}
            style={{
              height: 32,
              margin: 3,
              width: "100%",
              borderRadius: 7,
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              backgroundColor: index === activeTab && "white",
              color: index === activeTab ? "#2977A4" : "#1B4F6D",
              fontFamily: "SF Pro Text",
              fontStyle: "normal",
              fontWeight: "500",
              fontSize: 13,
              lineHeight: 20,
            }}
          >
            {i}
          </div>
        ))}
      </div>
    </div>
  );
}

BallSwitch.propTypes = {
  activeTab: PropTypes.number.isRequired,
  setActiveTab: PropTypes.func.isRequired,
  tabs: PropTypes.shape({
    map: PropTypes.func,
  }).isRequired,
};
